import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-53" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-54" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-55" data-mp="32pp764lzrz6i">
          SIGMA SMART<span className="align-super text-xs" data-id="element-56" data-mp="36q92r3qx2uqj">™</span> — THE 100+ TACTICAL REPORT AI PROMPTS<span className="align-super text-xs" data-id="element-57" data-mp="3uesbtlhsjbjo">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-58" data-mp="38qtqszerhoj">
          🏥 “Your last late-shift paperwork ends today.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-59" data-mp="3ldu34pweqfur">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="3qfji2gmr3do4">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-61" data-mp="2ezbc05841k7p" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-62" data-mp="3l8qxu8j60rtk">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-63" data-mp="3gc0ffejw1k4z" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-64" data-mp="3v9b09eif82dd">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3q727ai5jt0b9">
            Terms & Conditions
          </a>
          <span data-id="element-66" data-mp="33xc3sjqnopv">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="34pa1a0t5yjb">
            Privacy Policy
          </a>
          <span data-id="element-68" data-mp="hsadj51lhzrr">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-69" data-mp="huwlh5seehai">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-70" data-mp="qsqd43f7wmrc">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}